const TRANSFER_API_URL = `${process.env.REACT_APP_BACKEND_URL}synctrack/transfer`;

/**
 * Trigger Autodesk Docs → Google Drive flow
 * @param {Object} syncFlow - flow row (must contain instanceId)
 * @returns {Promise<any>}
 */
export const handleAutodeskDocsToGoogleDriveFlow = async (syncFlow) => {
  try {
    const token = localStorage.getItem('token');
    const flowId = syncFlow?.instanceId;

    if (!flowId) throw new Error('Instance ID is required to run this flow.');

    const url = `${TRANSFER_API_URL}/autodesk-docs-to-google-drive?flowId=${encodeURIComponent(flowId)}`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(`API Error ${response.status}: ${response.statusText} ${text}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in Autodesk Docs → Google Drive flow:', error);
    throw error;
  }
};